import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { PaqueteSeguros } from '../../_models/paquete-seguros';
import { PaqueteSegurosService } from '../../_services/paquete-seguros.service';
import {Alerta} from '../../_models/alerta';
import {GarantiasIdoneas} from '../../_models/garantias-idoneas';
import {GarantiaIdoneasService} from '../../_services/garantia-idoneas.service';

@Component( {
  selector: 'app-garantia-idoneas-listado',
  templateUrl: 'garantia-idoneas-listado.component.html'
} )

export class GarantiaIdoneasListadoComponent implements OnInit {

  garIdoneas: GarantiasIdoneas[] = [];
  carTabla = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();
  mosDetalle = false;
  garantiasSeleccionada: GarantiasIdoneas;

  constructor( private garantiaIdoneaServicio: GarantiaIdoneasService,
               private navServicio: NavService,
               private router: Router,
               private autServicio: AutenticacionService ) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/garantia-idoneas' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.LBL_CODIGO' ), sort: true },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.LBL_NOMBRE' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.busqueda = this.navServicio.getSearch( 'garantia-idoneas.component' );

    this.garantiaIdoneaServicio.listado().subscribe( garantia => {
      this.garIdoneas = garantia;
      this.carTabla = false;
      this.tabla.filterGlobal( this.busqueda, 'contains' );
    } );

    this.carTabla = false;
  }


  crear() {
    this.router.navigate( [ 'apl/garantia-idoneas/agregar' ] );
  }

  ver( palClave: GarantiasIdoneas ) {
    this.router.navigate( [ 'apl/garantia-idoneas/detalle/' + palClave.idGarantiaIdonea ] );
  }

  editar( palClave: GarantiasIdoneas ) {
    this.router.navigate( [ 'apl/garantia-idoneas/actualizar/' + palClave.idGarantiaIdonea ] )
  }

  setBusqueda() {
    this.navServicio.setSearch( 'garantia-idoneas.component', this.busqueda );
  }

  cerrar() {
    this.mosDetalle = false;
  }


}
